module.exports = __webpack_public_path__ + "img/double_plug_box1.385cf4b5.png";